angular.module('unergie.main')
.factory('ReferencesService', ($q, $rootScope, DataAccessReferences, DataAccessVariables) => {
    const refs = {}
    const vars = {}

    // Stubs for now
    refs.paymentTypes = Promise.resolve({
        TT: 'Échéancier',
        REC: 'Régularisation Client',
        REG: 'Facture de régul',
        MISC: 'Facture frais',
        BURN: 'Cagnotte/chq énergie',
        CIR: `Certificat d'irrécouvrabilité`,
        PERTE: `Perte`,
        OVER_INDEBT: `Surendettement`,
        CORRECTION: `Correction`,
    })


    refs.ttStatuses = Promise.resolve({
        0: 'A processer',
        10: 'En traitement',
        11: 'Traitement invoice',
        50: 'Ok',
        70: 'Annulé',
        71: 'Évolution modalité factu',
        90: 'En erreur',
        91: 'Erreur de modification',
        95: 'Incohérent HP/HC',
        99: 'Résilié',
    })

    refs.processStatuses = Promise.resolve({
        0: 'Initialisé',
        10: 'En traitement',
        50: 'Terminé Ok',
        85: 'Warning',
        90: 'En erreur',
    })

    refs.paymentStatuses = Promise.resolve({
        0: 'A transmettre',
        10: 'En traitement',
        11: 'En traitement CB',
        40: 'En attente validation',
        50: 'Transmis à slimpay',
        51: 'OK - En traitement',
        55: 'OK',
        70: 'Annulé',
        90: 'En erreur',
        91: 'Non présenté',
        93: 'rTransaction',
        94: 'Traitement rTransac',
        95: 'rTransac - OK',
        96: 'rTransac rejoué',
        98: 'Consommation de l\'avance',
    })

    refs.contractDraftStatus = Promise.resolve({
        0: 'En cours',
        10: 'Transformé',
        80: 'Annulé',
        90: 'En erreur',
    })

    refs.invoiceStatus = Promise.resolve({
        0: 'INITIAL',
        1: 'HOLD',
        11: 'HGZ',
        10: 'PROCESSING',
        12: 'PROCESSING_ACCOUNTING',
        50: 'DONE',
        501: 'SUCCESS_SIMU',
        502: 'SIMU_TO_CHECK',
        54: 'PARTIAL',
        55: 'INVOICED',
        70: 'CANCELLED',
        71: 'CANCELED_NO_CHANGE',
        90: 'ERROR',
        96: 'ERROR_SENDING',
        99: 'ERROR_SIMU',
    })

    refs.invoiceProcessStatus = Promise.resolve({
        0: 'INITIAL',
        10: 'PROCESSING',
        54: 'PARTIAL_SUCCESS',
        56: 'PARTIAL_SUCCESS_SIMU',
        55: 'SUCCESS',
        57: 'SUCCESS_SIMU',
        70: 'CANCELLED',
        90: 'ERROR',
        99: 'ERROR_SIMU',
    })

    refs.warningsTypes = Promise.resolve({
        301: 'Conso nulle',
        302: 'Conso basse',
        303: 'Conso beaucoup trop élevée',
        304: 'Conso anormalement élevée',
        305: 'Relève inférieure au précédent index',
        351: 'Conso nulle - forcée',
        352: 'Conso basse - forcée',
        354: 'Conso anormalement élevée - forcée',
        355: 'Relève inférieure au précédent index - forcée',
        400: 'R04 (Valeur Origine_Index_Debut non traitée)',
        401: 'R04 (pas de suppression en mode A)',
        402: 'R04 (plusieurs lignes modifiées mode K ou F)',
    })

    refs.searchHints = Promise.resolve([
        { id: 'LAST_HOUSEHOLD', label: 'Nom de l\'ancien occupant' },
        { id: 'METER_SERIAL', label: 'Matricule compteur' },
        { id: 'ADDRESS_ONLY', label: 'Adresse seule' },
        { id: 'ADDRESS_AND_COMPLEMENT', label: 'Adresse et complément' },
    ])

    const getRef = function (ref, isArray) {
        if (refs[ref]) {
            return refs[ref]
        }
        refs[ref] = (isArray) ? DataAccessReferences.refArray({ id: ref }).$promise : DataAccessReferences.ref({ id: ref }).$promise
        return refs[ref]
    }

    const getVar = function (vari, callback) {
        if (vars[vari]) {
            if (callback) {
                return callback(null, vars[vari])
            }
            return Promise.resolve(vars[vari])
        }
        return DataAccessVariables.get({ variables: vari }).$promise.then((variables) => {
            _.assign(vars, variables)
            if (callback) {
                return callback(null, vars[vari])
            }
            return vars[vari]
        })
        .catch((err) => callback(err))
    }

    return {
        getRef,
        getVar,
    }
})
